<template>
  <div v-show="showCookiesModal" class="popup-content">
    <div class="container-fluid font-16 padding-20">
      <div class="row">
        <div class="col-md-10 col-md-offset-1 margin-bottom-10">
          Nós usamos cookies, para melhorar a experiência do usuário em nosso site. Você pode encontrar mais informações na nossa
          <a :href="locashopURL + 'politicas-de-privacidade'" target="_blank" style="color: #ffffff;"> políticas de privacidade. </a>
          <br>
          Clicando em Aceitar você está concordando com nossa politica de privacidade e com a utilização dos cookies e outras ferramentas necessárias para melhorar sua experiência.
        </div>
          <hr>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
            <button class="btn btn-sm btn-primary" @click="setCookie">Aceitar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as config from '../../../config.js'

  export default {
    name: 'CookiesModal',
    data () {
      return {
        showCookiesModal: false,
        locashopURL: config.locashopURL
      }
    },
    created () {
      if (this.getCookie() === null) {
        this.showCookiesModal = true
      } else {
        this.showCookiesModal = false
      }
    },
    methods: {
      getCookie () {
        return this.$cookie.get('privacySettings')
      },
      setCookie () {
        this.$cookie.set('privacySettings', JSON.stringify({
          v: 1,
          t: Date.now(),
          consent: ['NECESSARY']
        }), {expires: '1Y'})
        this.showCookiesModal = false
      }
    }
  }
</script>

<style lang="scss" scoped>
@media only screen and (max-widht: 600px ) {
    .popup-content {
        min-height: 400px;
    }
}

.popup-content {
    position: fixed;
    bottom:0;
    left: 0;
    width: 100%;
    min-height: 100px;
    z-index: 9999;
    background-color: #272729;
    opacity: 0.8;
    box-shadow: 1px 1px 6px #636b6f;
    color: #ffffff;
}

hr {
    width: 100%;
    border: none;
    border-top: 4px solid #ff7f00;
}

a {
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// CoockiesModal.vue?3fb2afed